import { useData } from "@faedev/editor-utils";
import constants from "src/constants";

function getDataVideo(id: string) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useData(
    () =>
      fetch(`${constants.Paths.apiUrl}/videos/${id}`).then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error("API Error");
        }
      }),
    {}
  );
}

export default getDataVideo;
